import { render } from "./ShowVimsottariDasas.vue?vue&type=template&id=e4e05f54&scoped=true"
import script from "./ShowVimsottariDasas.vue?vue&type=script&lang=js"
export * from "./ShowVimsottariDasas.vue?vue&type=script&lang=js"

import "./ShowVimsottariDasas.vue?vue&type=style&index=0&id=e4e05f54&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4e05f54"]])

export default __exports__